module.exports = __webpack_public_path__ + "img/cooperation_unit_08.e11ab615.png";